<template>
  <div class="register container-fluid mb-5">
    <div class="row d-flex justify-content-center align-items-center mt-5" v-if="registerComp">
      <div class="col-md-4">
        <div class="card card-custom">
          <div class="card-body text-center">
            <!--<img class="img-fluid" src="@/assets/logo.png" alt="">-->
            <img class="img-fluid" src="@/assets/logo.png" alt="agtronix">
            <h3 class="text-center">Manager</h3>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label for="name">Name</label>
              <input type="text" placeholder="Your name" class="form-control form-control-sm" v-model.trim="user.name">
              <label for="email">Email</label>
              <input type="email" placeholder="example@mail.com" class="form-control form-control-sm"
                v-model.trim="user.email">
              <label for="password">Password</label>
              <input type="password" placeholder="******" class="form-control form-control-sm" v-model.trim="password">
              <label for="confirm">Confirm Password</label>
              <input type="password" placeholder="******" class="form-control form-control-sm" v-model.trim="confirm">
            </div>
            <div class="form-group">
              <vs-button block @click="register()">Register</vs-button>
            </div>
            <div class="form-group text-center">
              <a @click="activeComponent(2)" class="tpLink mr-3">Login</a>
              <a @click="activeComponent(3)" class="tpLink">Forgot Password</a>
            </div>
          </div>
        </div>
      </div>
 
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5" v-if="loginComp">

      <div class="col-md-4 ">
        <div class="card card-custom">
          <div class="card-body text-center">
            <img class="img-fluid" src="@/assets/logo.png" alt="agtronix">
            <h3 class="text-center">Manager</h3>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" placeholder="example@mail.com" class="form-control form-control-sm"
                v-model.trim="login.email">
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <input type="password" placeholder="******" class="form-control form-control-sm" v-model.trim="login.ps"
                v-on:keyup.enter="beforeSignIn()">
            </div>
            <div class="form-group">
              <vs-button block @click="beforeSignIn()">Login</vs-button>
            </div>
            <div class="form-group text-center">
              <a @click="activeComponent(0)" class="tpLink mr-3">Register</a>
              <a @click="activeComponent(3)" class="tpLink">Forgot Password</a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5" v-if="forgotComp">

      <div class="col-md-4">
        <div class="card card-custom">
          <div class="card-body text-center">
            <img class="img-fluid" src="@/assets/logo.png" alt="">
            <h3 class="text-center">Manager</h3>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" placeholder="Type your email" class="form-control form-control-sm"
                v-model.trim="recover.email" v-on:keyup.enter="recoverAccount()">
            </div>
            <div class="form-group">
              <vs-button block @click="recoverAccount()">Recover</vs-button>
            </div>
            <div class="form-group text-center">
              <a @click="activeComponent(2)" class="tpLink mr-3">Login</a>
              <a @click="activeComponent(0)" class="tpLink">Register</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5 mb-5" v-if="terms">
      <div class="col-md-2">
      </div>
      <div class="col-md-8">
        <div class="card card-custom">
          <div class="card-body text-center">
            <img class="img-fluid" src="@/assets/logo.png" alt="">
          </div>
          <div class="card-body">
            <h4>Terms and privacy policy</h4>
            <p class="text-muted text-justify">Disclaimer: We do not collect wallet Private Keys (PK)
              You are responsible for safekeeping Your wallet private key pairs. One thing we never ask is Private Key
              of your wallet
              (PK). You should never disclose it to anyone, it belongs to you and you only.<br><br>Log data<br>When you
              visit our website,
              our servers may automatically log the standard data provided by your web browser. It may include your
              computer’s Internet Protocol
              (IP) address, your browser type and version, the pages you visit, the time and date of your visit, the
              time spent on each page,
              or other details.<br><br>Device data<br>We may also collect data about the device you’re using to access
              our website. This data
              may include the device type, operating system, unique device identifiers, device settings, or geo-location
              data. What we collect
              can depend on the individual settings of your device and software. We recommend checking the policies of
              your device manufacturer
              or software provider to learn what information they make available to us.<br><br>Personal
              information<br>We may ask for personal
              information, such as your: Name, Email, Social media profiles, Website address, Wallet address, Your
              Transactions, Payment
              information.<br><br>Business data<br>Business data refers to data that accumulates over the normal course
              of operation on our platform. This may include transaction records, stored files, user profiles, analytics
              data and other metrics, as well as other types of information, created or generated,
              as users interact with our services.<br><br>1. Legal bases for processing<br>We will process your personal
              information lawfully,
              fairly and in a transparent manner. We collect and process information about you only where we have legal
              bases for doing so.<br>These legal bases depend on the services you use and how you use them, meaning we
              collect and use your information only where:
            </p>
            <div class="form-group text-right">
              <button type="button" @click="activeComponent(0)" class="btn mr-3 btn-danger">Decline</button>
              <button type="button" @click="accept()" class="btn btn-primary ">Accept</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
      </div>
    </div>
    <div class="row" v-if="displayMessages">
      <div class="col-md-12 text-center mt-5 mb-5">
        <transition name="fade">
          <span class="alert-danger" v-if="showErrorMessage">{{errorMessage}}</span>
          <span class="alert-success" v-if="showSuccessMessage">{{successMessage}} </span>
          <span class="alert-info" v-if="showInfoMessage">{{successInfo}}</span>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>
  import { firebaseApp } from "../fb";
  import validator from "validator";
  export default {
    name: 'register',
    data() {
      return {
        displayMessages: false,
        showErrorMessage: false,
        errorMessage: null,
        showSuccessMessage: false,
        successMessage: null,
        showInfoMessage: false,
        disabled: true,
        user: {
          name: '',
          email: '',
          encryP: ''
        },
        password: '',
        confirm: '',
        dbname: '',
        dbuser: '',
        dbpass: '',
        terms: false,
        registerComp: false,
        loginComp: true,
        forgotComp: false,
        login: {
          email: '',
          ps: ''
        },
        recover: {
          email: ''
        }
      };
    },

    mounted() {
      var vm = this
      vm.openLoadingBackground()

      firebaseApp.auth().onAuthStateChanged(function (user) {
        if (user) {
          firebaseApp.database().ref(`users/${user.uid}`)
            .orderByChild('email')
            .once('value', function (snapshot) {
              const element = snapshot.val();
              if (element.lvl == 0) {
                vm.$router.push('/Home');
              }
              if (element.lvl == 1) {
                vm.$router.push('/Main');
              }
              if (element.lvl == 2) {
                vm.$router.push('/Qr');
              }

            })
        }
      });


      // this.toggleBodyClass('addClass', 'custom-bg');

    },
    methods: {

      displayError(error) {
        var vm = this
        vm.displayMessages = true
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (vm.showErrorMessage) {
          vm.showErrorMessage = false
        }
        vm.showErrorMessage = true
        vm.errorMessage = `❌${error}`
        setTimeout(() => {
          vm.showErrorMessage = false
          vm.displayMessages = false
        }, 3000);
      },

      displaySuccess(message) {
        var vm = this
        vm.displayMessages = true
        if (vm.showSuccessMessage) {
          vm.showSuccessMessage = false
        }
        vm.showSuccessMessage = true
        vm.successMessage = `✅${message}`
        setTimeout(() => {
          vm.showSuccessMessage = false
          vm.displayMessages = false
        }, 3000);
      },



      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },

      openLoadingBackground() {
        // this.$vs.loading({background:'rgb(0,0,0,0.8)',color:'rgb(255, 255, 255)'})
        // setTimeout( ()=> {
        //   this.$vs.loading.close()
        //   this.loading=true
        // }, 1000);
      },

      recoverAccount() {
        var vm = this;
        var auth = firebaseApp.auth();
        auth.sendPasswordResetEmail(vm.recover.email).then(function () {
          vm.recover.email = ''
          vm.displaySuccess('Recovery email was sent');
        }).catch(function (error) {
          vm.displayError(error.message);
        });
      },
      beforeSignIn() {
        var vm = this
        localStorage.removeItem('l')
        if (vm.login.email.length == 0) {
          vm.displayError("Email is empty");
          return
        }
        firebaseApp.database().ref(`users/`)
          .orderByChild('email')
          .equalTo(vm.login.email.toLowerCase(),)
          .once('value', function (snapshot) {
            snapshot.forEach(function (child) {
              const element = child.val();
              localStorage.setItem('l', element.lvl)
              vm.signIn()
            });
          })
      },
      signIn() {
        const vm = this;
        firebaseApp
          .auth()
          .signInWithEmailAndPassword(vm.login.email.toLowerCase(), vm.login.ps)
          .catch(function (error) {
            var errorMessage = error.message;
            vm.displayError(errorMessage);
          });
      },
      activeComponent(component) {
        switch (component) {
          case 0:
            this.registerComp = true;
            this.terms = false;
            this.loginComp = false;
            this.forgotComp = false;
            break;
          case 1:
            this.registerComp = false;
            this.terms = true;
            this.loginComp = false;
            this.forgotComp = false;
            break;
          case 2:
            this.registerComp = false;
            this.terms = false;
            this.forgotComp = false;
            this.loginComp = true;
            break;
          case 3:
            this.registerComp = false;
            this.terms = false;
            this.loginComp = false;
            this.forgotComp = true;
            break;
        }
      },
      register() {
        const vm = this

        if (this.user.name.length == 0 || this.user.name.length > 50) {
          vm.displayError(
            "Name is empty, field must contain max 50 characters"
          );
          return;
        }

        if (!validator.isEmail(this.user.email)) {
          vm.displayError(
            "Email address is badly formatted"
          );
          return;
        }
        if (this.user.email.length > 50) {
          vm.displayError(
            "Email must contain max 50 characters"
          );
          return;
        }
        if (this.password.length < 6) {
          vm.displayError(
            "The password must contain at least 6 characters"
          );
          return;
        }
        if (this.password.length > 50) {
          vm.displayError(
            "The password must contain max 50 characters"
          );
          return;
        }
        if (this.password != this.confirm) {
          vm.displayError(
            "Passwords does not match"
          );
          return;
        }




        this.activeComponent(1)
      },
      accept() {
        const vm = this
        firebaseApp
          .auth()
          .createUserWithEmailAndPassword(this.user.email.toLowerCase(), this.password)
          .then((user) => {
            firebaseApp.database().ref('users/' + user.user.uid).update({
              name: vm.user.name,
              email: vm.user.email.toLowerCase(),
              encryP: vm.password,
              lvl: 1,
              dbname: '',
              dbuser: '',
              dbpass: '',
              registerAt: Date.now()
            })


          })
          .catch(function (error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            if (errorCode == "auth/weak-password") {
              vm.displayError(errorMessage);
            } else {
              vm.displayError(errorMessage);
            }
          });
      }
    },
    props: {
      msg: String
    }
  }
</script>